import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const KEY = "madinaty_cookie_ok";

export default function CookieConsent() {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => { localStorage.setItem(KEY, "1"); setShow(false); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:end-24 sm:max-w-md z-[65] glass-strong border border-white/10 rounded-2xl p-5 shadow-2xl flex items-start gap-4"
          data-testid="cookie-consent"
        >
          <Cookie size={24} className="text-primary shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm text-slate-300 leading-relaxed mb-3">
              {t.cookie.text} <Link to="/privacy" className="text-primary underline">{t.cookie.more}</Link>
            </p>
            <button onClick={accept} className="rounded-full px-5 py-2 text-sm font-bold text-[#04120a]" style={{ background: "var(--primary)" }} data-testid="cookie-accept">
              {t.cookie.accept}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
